var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.className},[_vm._t("default"),_vm._v(" "),_c('label',{attrs:{"for":_vm.inputId || _vm.name}}),_vm._v(" "),_c('input-file')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }